(function runMultiLogoOptimizer() {
  function calcT(key, fallback, vars) {
    var dict = window.__calculatorI18n || {};
    var text = dict[key] != null ? String(dict[key]) : String(fallback == null ? key : fallback);
    if (vars) Object.keys(vars).forEach(function (name) { text = text.split('{' + name + '}').join(String(vars[name])); });
    return text;
  }

  if (window.__impositionMultiOptimizerLoaded) return;
  window.__impositionMultiOptimizerLoaded = true;

  function unwrapEasyOrderRangePayload(obj) {
    if (!obj || typeof obj !== "object") return obj;
    if (Array.isArray(obj.prices) && obj.prices.length) return obj;
    if (obj.value && typeof obj.value === "object" && Array.isArray(obj.value.prices)) return obj.value;
    if (typeof obj.value === "string" && obj.value) {
      try {
        var inner = JSON.parse(obj.value);
        return unwrapEasyOrderRangePayload(inner);
      } catch (e2) {
        return obj;
      }
    }
    return obj;
  }

  (function normalizeDtfEasyOrderAuLogoRanges() {
    var r = window.dtfEasyOrderAuLogoRanges;
    if (typeof r === "string" && r) {
      try {
        r = JSON.parse(r);
      } catch (e) {
        r = null;
      }
    }
    window.dtfEasyOrderAuLogoRanges = unwrapEasyOrderRangePayload(r);
  })();

  var SPACING_CM = 1;
  var LOGO_DEFAULT_WIDTH_CM = "10";
  var LOGO_DEFAULT_HEIGHT_CM = "10";
  var LOGO_DEFAULT_QTY = "10";
  function onReady(cb) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", cb, { once: true });
      return;
    }
    cb();
  }

  function parseDelayDays(raw) {
    var text = String(raw || "").trim().toLowerCase();
    if (!text) return null;

    // Canonical Shopify labels: J+5 / J + 2 / J0.
    var jMatch = text.match(/\bj\s*(?:\+\s*)?(\d+)\b/i);
    if (jMatch && jMatch[1] != null) {
      return Math.max(0, parseInt(jMatch[1], 10) || 0);
    }

    // Localized lead-time labels. Keep matching independent from storefront locale
    // because translated variant options can be returned by Shopify on /en,/es,/it.
    var localizedDays = text.match(
      /\b(\d+)\s*(?:working\s*days?|business\s*days?|jours?\s*ouvr(?:é|e|és|es)?|giorn(?:o|i)\s*lavorativ(?:o|i)|d[ií]as?\s*(?:laborables|h[aá]biles))\b/i
    );
    if (localizedDays && localizedDays[1] != null) {
      return Math.max(0, parseInt(localizedDays[1], 10) || 0);
    }

    // Some localized variants/metaobjects expose the commercial plan name only.
    if (/\b(?:urgent|urgence|urgente)\b/i.test(text)) return 0;
    if (/\b(?:express|flash|expr[eé]s)\b/i.test(text)) return 1;
    if (/\b(?:standard|est[aá]ndar)\b/i.test(text)) return 2;
    if (/\b(?:eco|economy|economique|économique|economico|económico)\b/i.test(text)) return 5;

    // Last-resort numeric fallback (e.g. "Lead time: 5").
    var fallback = text.match(/\b(\d{1,2})\b/);
    if (fallback && fallback[1] != null) {
      return Math.max(0, parseInt(fallback[1], 10) || 0);
    }
    return null;
  }

  function normalizeDelayLabel(raw) {
    var day = parseDelayDays(raw);
    if (day == null) return "";
    return day === 0 ? "J 0" : "J + " + day + " jours ouvrés";
  }

  function variantOptionText(variant) {
    return [variant.title, variant.option1, variant.option2, variant.option3].filter(Boolean).join(" | ");
  }

  function variantDelayLabel(variant) {
    return normalizeDelayLabel(variantOptionText(variant));
  }

  function normalizeFormatMatchText(raw) {
    var text = String(raw || "").trim().toLowerCase();
    try {
      text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    } catch (e) {}

    // Shopify can translate the Mètre option on localized storefronts.
    // Canonicalize the common FR/EN/ES/IT labels so a French calculator
    // format value ("Mètre") can still match an English variant ("Meter").
    text = text.replace(/\b(?:metre|meter|metro|metri)\b/g, "meter");
    return text;
  }

  function variantMatchesFormat(variant, formatName) {
    var haystack = normalizeFormatMatchText(variantOptionText(variant));
    var needle = normalizeFormatMatchText(formatName);
    return !!needle && haystack.indexOf(needle) >= 0;
  }

  // Some EN product translations currently replace the A3+ option value on
  // single-format serigraphy products with unrelated translated content
  // (for example "Heart | 8.5 x 8.5 cm"). The variant IDs/prices are still
  // the correct product variants. For products that only ever support A3+,
  // use the calculator's canonical product sign as the source of truth for
  // format matching instead of localized option text.
  function productUsesFixedA3PlusFormat(product, formatName) {
    if (!product || normalizeFormatMatchText(formatName) !== "a3+") return false;
    var sign = String(product.sign || product.displayName || "").trim();
    return (
      sign === "TRANSFERT_SERIGRAPHIQUE_MONOCHROME_COULEUR" ||
      sign === "TRANSFERT_SERIGRAPHIQUE_OR_/_ARGENT" ||
      sign === "TRANSFERT_SERIGRAPHIQUE_FLUO"
    );
  }

  function variantsForFormat(product, formatName) {
    if (!product || !Array.isArray(product.variants)) return [];
    if (productUsesFixedA3PlusFormat(product, formatName)) {
      return product.variants.slice();
    }
    return product.variants.filter(function (variant) {
      return variantMatchesFormat(variant, formatName);
    });
  }

  function pickVariantForDelay(product, formatName, delayDays) {
    if (!product || !Array.isArray(product.variants)) return null;
    var filtered = variantsForFormat(product, formatName);
    if (!filtered.length) return null;
    if (delayDays == null) return filtered[0];

    var candidates = filtered
      .map(function (variant) {
        return {
          variant: variant,
          days: parseDelayDays(variantOptionText(variant))
        };
      })
      .filter(function (entry) {
        return entry.days != null;
      });
    if (!candidates.length) return filtered[0];

    candidates.sort(function (a, b) {
      var da = Math.abs(a.days - delayDays);
      var db = Math.abs(b.days - delayDays);
      if (da !== db) return da - db;
      return a.days - b.days;
    });
    return candidates[0].variant;
  }

  function pickVariantPrice(product, formatName, selectedDelay) {
    if (!product || !Array.isArray(product.variants)) return null;
    var filtered = variantsForFormat(product, formatName);
    if (!filtered.length) return null;

    var delayNorm = normalizeDelayLabel(selectedDelay);
    var exact = filtered.find(function (variant) {
      return variantDelayLabel(variant) === delayNorm;
    });

    var picked = exact;
    if (!picked) {
      var requestedDays = parseDelayDays(selectedDelay);
      if (requestedDays != null) {
        var candidates = filtered
          .map(function (variant) {
            return {
              variant: variant,
              days: parseDelayDays(variantOptionText(variant))
            };
          })
          .filter(function (entry) {
            return entry.days != null;
          });
        if (candidates.length) {
          candidates.sort(function (a, b) {
            var da = Math.abs(a.days - requestedDays);
            var db = Math.abs(b.days - requestedDays);
            if (da !== db) return da - db;
            return a.days - b.days;
          });
          picked = candidates[0].variant;
        }
      }
    }
    if (!picked) picked = filtered[0];

    return {
      price: Number(picked.price || 0) / 100,
      priceCents: Number(picked.price || 0),
      handle: picked.handle || product.handle,
      id: picked.id,
      variant: picked
    };
  }


  // ---------------------------------------------------------------------------
  // Sherpa Volume pricing
  // Mirrors the matching + rounding rules used by assets/sherpa-volume-table.js.
  // Legacy Shopacado/Appikon pricing is intentionally NOT used for calculator
  // planche prices anymore.
  // ---------------------------------------------------------------------------
  function sherpaToArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function sherpaNormalizeId(value) {
    return String(value || "").trim();
  }

  function sherpaIdVariants(id) {
    var raw = sherpaNormalizeId(id);
    if (!raw) return [];
    var variants = [raw];
    var productMatch = raw.match(/\/Product\/(\d+)$/);
    if (productMatch) variants.push(productMatch[1]);
    var collectionMatch = raw.match(/\/Collection\/(\d+)$/);
    if (collectionMatch) variants.push(collectionMatch[1]);
    return variants;
  }

  function sherpaIdsMatch(a, b) {
    var aVariants = sherpaIdVariants(a);
    var bVariants = new Set(sherpaIdVariants(b));
    return aVariants.some(function (value) {
      return bVariants.has(value);
    });
  }

  function sherpaTagSet(tags) {
    return new Set(
      sherpaToArray(tags)
        .map(function (tag) { return String(tag || "").trim(); })
        .filter(Boolean)
    );
  }

  function sherpaExtractRulesList(campaigns) {
    if (Array.isArray(campaigns)) return campaigns;
    if (campaigns && Array.isArray(campaigns.rules)) return campaigns.rules;
    return [];
  }

  function sherpaGetRuleProductIds(rule) {
    return []
      .concat(sherpaToArray(rule && rule.productIds))
      .concat(
        sherpaToArray(rule && rule.products).map(function (product) {
          return product && product.id;
        })
      )
      .filter(Boolean);
  }

  function sherpaGetRuleCollectionIds(rule) {
    return []
      .concat(sherpaToArray(rule && rule.collectionIds))
      .concat(
        sherpaToArray(rule && rule.collections).map(function (collection) {
          return collection && collection.id;
        })
      )
      .filter(Boolean);
  }

  function sherpaCustomerMatchesRule(rule, customerTags) {
    var required = sherpaToArray(rule && rule.customerTags);
    if (!required.length) return true;
    return required.some(function (tag) {
      return customerTags.has(String(tag || "").trim());
    });
  }

  function sherpaProductCollectionIds(product) {
    return sherpaToArray(product && product.collectionIds)
      .concat(sherpaToArray(product && product.collections))
      .map(function (collection) {
        return sherpaNormalizeId(
          collection && typeof collection === "object" ? collection.id : collection
        );
      })
      .filter(Boolean);
  }

  function sherpaLineMatchesRule(product, rule) {
    if (!product) return false;

    var productId =
      product.admin_graphql_api_id ||
      product.gid ||
      product.id;
    var productTags = sherpaTagSet(product.tags);
    var ruleProductIds = sherpaGetRuleProductIds(rule);
    var ruleCollectionIds = sherpaGetRuleCollectionIds(rule);

    if (
      ruleProductIds.some(function (id) {
        return sherpaIdsMatch(id, productId);
      })
    ) {
      return true;
    }

    var productCollectionIds = sherpaProductCollectionIds(product);
    if (
      ruleCollectionIds.some(function (id) {
        return productCollectionIds.some(function (productCollectionId) {
          return sherpaIdsMatch(id, productCollectionId);
        });
      })
    ) {
      return true;
    }

    if (
      sherpaToArray(rule && rule.tags).some(function (tag) {
        return productTags.has(String(tag || "").trim());
      })
    ) {
      return true;
    }

    // Same behavior as sherpa-volume-table.js: a customer-only rule is allowed.
    var hasStandaloneCustomerTarget =
      !ruleProductIds.length &&
      !ruleCollectionIds.length &&
      !sherpaToArray(rule && rule.tags).length &&
      sherpaToArray(rule && rule.customerTags).length > 0;

    return hasStandaloneCustomerTarget;
  }

  function sherpaResolvePricingProductContext(product, picked) {
    var contexts = window.__impositionSherpaProductContexts || {};
    var handle =
      (picked && picked.handle) ||
      (picked && picked.variant && picked.variant.handle) ||
      (product && product.handle) ||
      "";
    var ctx = handle ? contexts[handle] : null;

    if (!ctx) return product;

    return {
      id: ctx.id != null ? ctx.id : (product && product.id),
      gid: ctx.gid || (product && product.gid),
      admin_graphql_api_id:
        ctx.gid ||
        ctx.admin_graphql_api_id ||
        (product && product.admin_graphql_api_id),
      handle: ctx.handle || handle,
      title: ctx.title || (product && product.title),
      tags: sherpaToArray(ctx.tags).length
        ? ctx.tags
        : sherpaToArray(product && product.tags),
      collectionIds: sherpaToArray(ctx.collectionIds).length
        ? ctx.collectionIds
        : sherpaProductCollectionIds(product),
      collections: sherpaToArray(ctx.collections)
    };
  }

  function sherpaDiscountContext() {
    return window.__transferCalculatorDiscounts || window.__sherpaDiscounts || {};
  }

  function sherpaResolveCampaign(product) {
    var data = sherpaDiscountContext();
    var customerTags = sherpaTagSet(data.customer && data.customer.tags);
    var activeRules = sherpaExtractRulesList(data.campaigns)
      .filter(function (rule) {
        return String((rule && rule.status) || "").toLowerCase() === "active";
      })
      .sort(function (a, b) {
        var pa = a && a.priority != null ? a.priority : Infinity;
        var pb = b && b.priority != null ? b.priority : Infinity;
        return pa - pb;
      });

    for (var i = 0; i < activeRules.length; i++) {
      var rule = activeRules[i];
      if (!sherpaLineMatchesRule(product, rule)) continue;
      if (!sherpaCustomerMatchesRule(rule, customerTags)) continue;
      return rule;
    }
    return null;
  }

  function sherpaPickTierPercent(tiers, quantity) {
    if (!tiers || typeof tiers !== "object") return null;
    var sorted = Object.keys(tiers)
      .map(Number)
      .filter(Number.isFinite)
      .sort(function (a, b) { return a - b; });

    var chosen = null;
    for (var i = 0; i < sorted.length; i++) {
      if (quantity >= sorted[i]) chosen = Number(tiers[String(sorted[i])]);
      else break;
    }
    return Number.isFinite(chosen) ? chosen : null;
  }

  function sherpaDiscountedLineTotalCents(unitPriceCents, quantity, percentOff) {
    var unit = Number(unitPriceCents);
    var qty = Number(quantity);
    var percent = Number(percentOff);
    if (!Number.isFinite(unit) || !Number.isFinite(qty) || qty <= 0) return 0;
    if (!Number.isFinite(percent) || percent <= 0) return Math.round(unit * qty);

    // Must match Sherpa Volume Table / Shopify Function rounding:
    // floor discount PER UNIT, then multiply by quantity.
    var perUnitDiscountFloorCents = Math.floor((unit * percent) / 100);
    return (unit - perUnitDiscountFloorCents) * qty;
  }

  function sherpaVolumePriceForCalculator(product, productSign, formatName, selectedDelay, sheets) {
    var data = sherpaDiscountContext();
    var isSeri = isSerigraphicProduct(productSign);
    var picked = pickVariantPrice(product, formatName, selectedDelay);

    if (!data || data.enabled !== true || !picked || !(picked.priceCents > 0)) {
      if (isSeri) {
      }
      return null;
    }

    var pricingProduct = sherpaResolvePricingProductContext(product, picked);
    var campaign = sherpaResolveCampaign(pricingProduct);
    var rawPercent = campaign ? sherpaPickTierPercent(campaign.tiers, Number(sheets)) : null;
    var percentOff = Number.isFinite(rawPercent) && rawPercent > 0 ? rawPercent : 0;

    // Preserve existing calculator base-price behavior if no Sherpa campaign/tier
    // applies. This prevents unrelated DTF area-pricing behavior from changing.
    if (!campaign || !(percentOff > 0)) {
      if (isSeri) {
      }
      return null;
    }

    var lineCents = sherpaDiscountedLineTotalCents(
      picked.priceCents,
      Number(sheets),
      percentOff
    );
    var discountedUnitCents = Number(sheets) > 0 ? lineCents / Number(sheets) : 0;

    if (isSeri) {
    }

    return lineCents / 100;
  }

  function customerHasTopTag() {
    if (window.customerIsTop5) return true;
    var discountData = sherpaDiscountContext();
    var sherpaTags = sherpaToArray(
      discountData && discountData.customer && discountData.customer.tags
    );
    if (sherpaTags.some(function (tag) { return String(tag || "").indexOf("TOP") >= 0; })) {
      return true;
    }
    var legacyTags = String((window.appikon && window.appikon.customer && window.appikon.customer.tags) || "");
    return legacyTags.indexOf("TOP") >= 0;
  }

  function resolveIsTopCustomer() {
    return customerHasTopTag();
  }

  function resolveUserIsTopForVolRows() {
    return !!(window.userIsTop || customerHasTopTag());
  }

  function pickPriceTierRow(priceRows, totalArea) {
    var eligible = priceRows.filter(function(r) { return Number(r.area || 0) <= totalArea; });
    if (eligible.length) {
      return eligible.reduce(function(a, b) { return Number(b.area) > Number(a.area) ? b : a; });
    }
    return priceRows.reduce(function(a, b) { return Number(a.area) < Number(b.area) ? a : b; });
  }

  /**
   * Easy Order au logo : `prices[].area` = borne basse (cm²) de la tranche.
   * Surface S est dans [area_i, area_{i+1}) ; la dernière tranche va jusqu'à +∞.
   * (Évite de confondre avec un simple max(area) quand les seuils ne sont pas alignés sur la surface exacte.)
   */
  function pickPriceTierRowForEasyOrderLogoSurface(priceRows, totalArea) {
    if (!priceRows || !priceRows.length) return null;
    var ta = Number(totalArea);
    if (!Number.isFinite(ta) || ta < 0) ta = 0;
    var sorted = priceRows
      .map(function(r) {
        return { row: r, lo: Number(r.area || 0) };
      })
      .sort(function(a, b) {
        return a.lo - b.lo;
      });
    if (ta < sorted[0].lo) return sorted[0].row;
    var i;
    for (i = 0; i < sorted.length; i++) {
      var hi = i + 1 < sorted.length ? sorted[i + 1].lo : Infinity;
      if (ta >= sorted[i].lo && ta < hi) return sorted[i].row;
    }
    return sorted[sorted.length - 1].row;
  }

  var FORMAT_TO_RANGE_KEY = { A4: "a4", A3: "a3", A2: "a2", "Mètre": "meter", Metre: "meter" };

  function getDelayMultiplierFromRangeSource(rangeSource, product, formatName, selectedDelay) {
    var selectedDays = parseDelayDays(selectedDelay);
    if (selectedDays == null) return 1;
    var delays = rangeSource && Array.isArray(rangeSource.delivery_delay) ? rangeSource.delivery_delay : [];
    if (delays.length) {
      var isTop = resolveIsTopCustomer();
      var normalizedSelected = normalizeDelayLabel(selectedDelay);
      var delayItem = null;
      for (var di = 0; di < delays.length; di++) {
        var dTitle = String(delays[di].title || delays[di].plan || "");
        if (normalizeDelayLabel(dTitle) === normalizedSelected) { delayItem = delays[di]; break; }
      }
      if (!delayItem) {
        for (var di2 = 0; di2 < delays.length; di2++) {
          var dTitle2 = String(delays[di2].title || delays[di2].plan || "");
          if (parseDelayDays(dTitle2) === selectedDays) { delayItem = delays[di2]; break; }
        }
      }
      if (delayItem) {
        var mult = isTop
          ? Number(delayItem.price_for_top || delayItem.price || 1)
          : Number(delayItem.price || 1);
        if (Number.isFinite(mult) && mult > 0) return mult;
      }
    }
    return getDelayMultiplier(product, formatName, selectedDelay);
  }

  function getDelayMultiplier(product, formatName, selectedDelay) {
    var selectedDays = parseDelayDays(selectedDelay);
    if (selectedDays == null) return 1;
    var key = FORMAT_TO_RANGE_KEY[formatName];
    var source = key && window.priceRangesAll && window.priceRangesAll[key];
    var delays = source && Array.isArray(source.delivery_delay) ? source.delivery_delay : [];
    if (delays.length) {
      var isTop = resolveIsTopCustomer();
      var normalizedSelected = normalizeDelayLabel(selectedDelay);
      var delayItem = null;
      for (var di = 0; di < delays.length; di++) {
        var dTitle = String(delays[di].title || delays[di].plan || "");
        if (normalizeDelayLabel(dTitle) === normalizedSelected) { delayItem = delays[di]; break; }
      }
      if (!delayItem) {
        for (var di2 = 0; di2 < delays.length; di2++) {
          var dTitle2 = String(delays[di2].title || delays[di2].plan || "");
          if (parseDelayDays(dTitle2) === selectedDays) { delayItem = delays[di2]; break; }
        }
      }
      if (delayItem) {
        var mult = isTop
          ? Number(delayItem.price_for_top || delayItem.price || 1)
          : Number(delayItem.price || 1);
        if (Number.isFinite(mult) && mult > 0) return mult;
      }
    }
    var selectedVariant = pickVariantForDelay(product, formatName, selectedDays);
    var baselineVariant = pickVariantForDelay(product, formatName, 5);
    var selPrice = selectedVariant ? Number(selectedVariant.price || 0) / 100 : 0;
    var basPrice = baselineVariant ? Number(baselineVariant.price || 0) / 100 : 0;
    return (selPrice > 0 && basPrice > 0) ? selPrice / basPrice : 1;
  }

  function areaPriceFromTable(formatName, sheetCount) {
    var key = FORMAT_TO_RANGE_KEY[formatName];
    if (!key) return null;
    var source = window.priceRangesAll && window.priceRangesAll[key];
    var priceRows = source && source.prices ? source.prices : [];
    if (!priceRows.length) return null;
    var dims = window.CalculatorEngine && window.CalculatorEngine.FORMAT_DIMENSIONS[formatName];
    if (!dims) return null;
    var totalArea = dims.width * dims.height * sheetCount;
    var row = pickPriceTierRow(priceRows, totalArea);
    var isTop = resolveIsTopCustomer();
    var standardRate = Number(row.price || 0);
    var topRate = Number(row.price_for_top || 0);
    if (isTop) {
      if (topRate <= 0) return null;
      return topRate * totalArea;
    }
    if (!Number.isFinite(standardRate) || standardRate <= 0) return null;
    return standardRate * totalArea;
  }

  function normalizeApoVolRows(volRows) {
    var arr = Array.isArray(volRows) ? volRows.slice() : [];
    if (!resolveUserIsTopForVolRows() || arr.length < 1) {
      arr.unshift({ quantity: 1, price: { amount: 0 } });
    }
    return arr;
  }

  function pickApoDiscountAmountForQty(volRows, qty) {
    var base = normalizeApoVolRows(volRows);
    var currentQuantity = Math.max(1, Math.floor(Number(qty) || 1));
    var picked = null;
    base.forEach(function (item, itemIdx) {
      if (item.quantity > currentQuantity) {
        if (itemIdx === 0) {
          picked = { quantity: currentQuantity, price: { amount: 0 } };
        }
        return;
      }
      picked = { quantity: currentQuantity, price: item.price || { amount: 0 } };
    });
    return picked && picked.price ? Number(picked.price.amount || 0) : 0;
  }

  function priceFromShopacadoParityWithRows(product, formatName, selectedDelay, sheetQty, volRows) {
    if (!volRows || !volRows.length) return null;
    var vp = pickVariantPrice(product, formatName, selectedDelay);
    if (!vp || vp.price <= 0) return null;
    var amount = pickApoDiscountAmountForQty(volRows, sheetQty);
    var discountUnit = vp.price * ((100 - amount) / 100);
    return sheetQty * discountUnit;
  }

  function isMetreFormatName(formatName) {
    var s = String(formatName || "").toLowerCase();
    return s.indexOf("mètre") >= 0 || s === "metre" || s === "mètre";
  }

  function pickShopacadoProductContext(productSign, formatName) {
    var map = window.impositionShopacadoProducts;
    if (!map) return null;
    var entry = map[productSign];
    if (!entry) return null;
    if (entry.metre || entry.planche) {
      return isMetreFormatName(formatName) ? entry.metre || null : entry.planche || null;
    }
    return entry.default || entry;
  }

  function getVolRowsForProductFormat(productSign, formatName) {
    var ctx = pickShopacadoProductContext(productSign, formatName);
    if (!ctx || !ctx.id) return null;
    var cache = window.__impositionVolRowsByProductId || {};
    var rows = cache[ctx.id];
    return Array.isArray(rows) && rows.length ? rows : null;
  }

  function getEasyOrderDtfShopacadoContext() {
    var map = window.impositionShopacadoProducts;
    var eo = map && map.DTF && map.DTF.easyOrder;
    return eo && eo.id ? eo : null;
  }

  function getVolRowsForEasyOrderDtfProduct() {
    var ctx = getEasyOrderDtfShopacadoContext();
    if (!ctx || !ctx.id) return null;
    var cache = window.__impositionVolRowsByProductId || {};
    var rows = cache[ctx.id];
    return Array.isArray(rows) && rows.length ? rows : null;
  }

  var EASY_ORDER_FORMAT_OPTION2 = [
    { opt2: "Coeur | 8.5 x 8.5 cm", w: 8.5, h: 8.5 },
    { opt2: "A4 | 21 x 28 cm", w: 21, h: 28 },
    { opt2: "A3 | 28 x 42 cm", w: 28, h: 42 },
    { opt2: "A2 | 42 x 58 cm", w: 42, h: 58 }
  ];

  function logoFitsPreset(lw, lh, tw, th) {
    var w = Number(lw);
    var h = Number(lh);
    if (!(w > 0) || !(h > 0) || !(tw > 0) || !(th > 0)) return false;
    return (w <= tw && h <= th) || (w <= th && h <= tw);
  }

  function easyOrderFormatOption2ForLogo(logo) {
    var lw = logo.width;
    var lh = logo.height;
    for (var i = 0; i < EASY_ORDER_FORMAT_OPTION2.length; i++) {
      var t = EASY_ORDER_FORMAT_OPTION2[i];
      if (logoFitsPreset(lw, lh, t.w, t.h)) return t.opt2;
    }
    return EASY_ORDER_FORMAT_OPTION2[EASY_ORDER_FORMAT_OPTION2.length - 1].opt2;
  }

  function easyOrderEffectivePriceSource() {
    var m = window.dtfEasyOrderAuLogoRanges;
    if (m && Array.isArray(m.prices) && m.prices.length) return m;
    var lg = window.priceRangesAll && window.priceRangesAll.logo;
    if (lg && Array.isArray(lg.prices) && lg.prices.length) return lg;
    return null;
  }

  function easyOrderAuLogoRangesHasPrices() {
    return !!easyOrderEffectivePriceSource();
  }

  function getDtfPlancheProductForDelay() {
    var prods = window.calculatorProducts;
    if (!prods || !prods.length) return null;
    for (var i = 0; i < prods.length; i++) {
      if (prods[i].sign === "DTF") return prods[i];
    }
    return null;
  }

  function easyOrderLineTotalHtFromMetaobject(logo, selectedDelay) {
    var priceSource = easyOrderEffectivePriceSource();
    if (!priceSource) return null;
    var qty = Math.max(0, Math.floor(Number(logo.quantity || 0)));
    if (qty <= 0) return 0;
    var w = Number(logo.width);
    var h = Number(logo.height);
    if (!(w > 0) || !(h > 0)) return 0;
    var surface = w * h * qty;
    var row = pickPriceTierRowForEasyOrderLogoSurface(priceSource.prices, surface);
    if (!row) return null;
    var isTop = resolveIsTopCustomer();
    var standardRate = Number(row.price || 0);
    var topRate = Number(row.price_for_top || 0);
    var baseHt;
    if (isTop) {
      if (topRate <= 0) return null;
      baseHt = topRate * surface;
    } else {
      if (!Number.isFinite(standardRate) || standardRate <= 0) return null;
      baseHt = standardRate * surface;
    }
    var planche = getDtfPlancheProductForDelay();
    if (!planche) return baseHt;
    var mult = 1;
    if (
      priceSource &&
      Array.isArray(priceSource.delivery_delay) &&
      priceSource.delivery_delay.length
    ) {
      mult = getDelayMultiplierFromRangeSource(
        priceSource,
        planche,
        "A4",
        selectedDelay
      );
    } else {
      mult = getDelayMultiplier(planche, "A4", selectedDelay);
    }
    return baseHt * mult;
  }

  function easyOrderLineTotalHtFromVariants(easyProduct, logo, selectedDelay) {
    if (!easyProduct || !Array.isArray(easyProduct.variants)) return 0;
    var option2 = easyOrderFormatOption2ForLogo(logo);
    var qty = Math.max(0, Math.floor(Number(logo.quantity || 0)));
    if (qty <= 0) return 0;

    var sherpaPrice = sherpaVolumePriceForCalculator(
      easyProduct,
      "DTF_EASY_ORDER",
      option2,
      selectedDelay,
      qty
    );
    if (sherpaPrice != null) return sherpaPrice;

    var vp = pickVariantPrice(easyProduct, option2, selectedDelay);
    return vp && vp.price > 0 ? vp.price * qty : 0;
  }

  function easyOrderLineTotalHt(easyProduct, logo, selectedDelay) {
    var fromMeta = easyOrderLineTotalHtFromMetaobject(logo, selectedDelay);
    if (fromMeta !== null) return fromMeta;
    return easyOrderLineTotalHtFromVariants(easyProduct, logo, selectedDelay);
  }

  function getEasyOrderMinPriceHt() {
    var raw = window.easyOrderMinPriceHt;
    if (raw == null || raw === "") return 4.95;
    var value = Number(String(raw).replace(",", ".").trim());
    if (!Number.isFinite(value) || value < 0) return 4.95;
    return value;
  }

  function applyEasyOrderMinTotalHt(totalHt) {
    var minHt = getEasyOrderMinPriceHt();
    if (!(minHt > 0) || !Number.isFinite(totalHt) || totalHt <= 0) return totalHt;
    return totalHt < minHt ? minHt : totalHt;
  }

  function calculatorLineTotalPrice(product, productSign, formatName, selectedDelay, sheets) {
    var isSeri = isSerigraphicProduct(productSign);
    var sherpaPrice = sherpaVolumePriceForCalculator(
      product,
      productSign,
      formatName,
      selectedDelay,
      sheets
    );

    if (sherpaPrice != null) {
      if (isSeri) {
      }
      return sherpaPrice;
    }

    var tablePrice = productSign === "DTF" ? areaPriceFromTable(formatName, sheets) : null;
    var fallback = pickVariantPrice(product, formatName, selectedDelay);
    var perSheet = fallback ? Number(fallback.price || 0) : 0;

    if (productSign === "DTF" && tablePrice != null) {
      return tablePrice * getDelayMultiplier(product, formatName, selectedDelay);
    }

    if (perSheet > 0) {
      var variantTotal = perSheet * sheets;
      if (isSeri) {
      }
      return variantTotal;
    }

    if (isSeri) {
    }
    return tablePrice != null ? tablePrice : 0;
  }

  window.__impositionVolRowsByProductId = window.__impositionVolRowsByProductId || {};
  var volRowsFetchPromisesByProductId = {};
  var appikonDiscountEndpointPromise = null;

  function getAppikonDiscountEndpoint() {
    if (appikonDiscountEndpointPromise) return appikonDiscountEndpointPromise;
    appikonDiscountEndpointPromise = new Promise(function (resolve) {
      var n = 0;
      function tick() {
        var url = window.appikonDiscount && window.appikonDiscount.settings && window.appikonDiscount.settings.app_root_url;
        if (url) {
          resolve(url);
          return;
        }
        if (++n >= 120) {
          resolve(null);
          return;
        }
        window.setTimeout(tick, 50);
      }
      tick();
    });
    return appikonDiscountEndpointPromise;
  }

  function assignVolRowsToApoGlobals(rows) {
    if (!rows || !rows.length) return;
    window.appikon = window.appikon || { customer: {} };
    window.appikon.vol_rows = rows;
    if (!window.isMyApoData) window.isMyApoData = window.appikon;
    else window.isMyApoData.vol_rows = rows;
  }

  function fetchVolRowsForProductContext(ctx) {
    if (!ctx || !ctx.id || typeof fetch !== "function") return Promise.resolve(false);
    var id = ctx.id;
    var cached = window.__impositionVolRowsByProductId[id];
    if (cached && cached.length) return Promise.resolve(true);
    if (volRowsFetchPromisesByProductId[id]) return volRowsFetchPromisesByProductId[id];

    volRowsFetchPromisesByProductId[id] = getAppikonDiscountEndpoint().then(function (endpoint) {
      if (!endpoint) return false;
      window.appikon = window.appikon || { customer: {} };
      window.appikon.adp_page = "product";
      window.appikon.product = {
        id: ctx.id,
        price: ctx.price,
        variant_price: String(ctx.variantPrice != null ? ctx.variantPrice : "")
      };
      window.appikon.product_collections = ctx.collectionIds ? ctx.collectionIds.slice() : [];
      return fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        credentials: "same-origin",
        body: JSON.stringify(window.appikon)
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (data && data.vol_rows && data.vol_rows.length) {
            window.__impositionVolRowsByProductId[id] = data.vol_rows;
            assignVolRowsToApoGlobals(data.vol_rows);
            return true;
          }
          return false;
        })
        .catch(function () {
          return false;
        });
    });
    return volRowsFetchPromisesByProductId[id];
  }

  function collectShopacadoContextsForProductSign(productSign) {
    var entry = window.impositionShopacadoProducts && window.impositionShopacadoProducts[productSign];
    if (!entry || typeof entry !== "object") return [];
    var raw = [];
    var known = { metre: 1, planche: 1, default: 1, easyOrder: 1 };
    ["metre", "planche", "default", "easyOrder"].forEach(function (k) {
      if (entry[k] && entry[k].id) raw.push(entry[k]);
    });
    Object.keys(entry).forEach(function (k) {
      if (known[k]) return;
      var v = entry[k];
      if (v && typeof v === "object" && v.id) raw.push(v);
    });
    var seen = {};
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var c = raw[i];
      if (!c || !c.id || seen[c.id]) continue;
      seen[c.id] = true;
      out.push(c);
    }
    return out;
  }

  function ensureShopacadoVolRowsForProductSign(productSign) {
    var contexts = collectShopacadoContextsForProductSign(productSign);
    if (!contexts.length || typeof fetch !== "function") return Promise.resolve(false);
    return Promise.all(contexts.map(fetchVolRowsForProductContext)).then(function (results) {
      return results.some(Boolean);
    });
  }

  function drawPreview(target, placementSource) {
    target.innerHTML = "";
    var canvas = document.createElement("canvas");
    canvas.width = 260;
    canvas.height = 180;
    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    var fmt = placementSource.format;
    var placements = placementSource.placements || [];
    if (!fmt || !fmt.width || !fmt.height) {
      target.appendChild(canvas);
      return;
    }

    var scaleX = canvas.width / fmt.width;
    var scaleY = canvas.height / fmt.height;
    var scale = Math.min(scaleX, scaleY);
    var offsetX = (canvas.width - fmt.width * scale) / 2;
    var offsetY = (canvas.height - fmt.height * scale) / 2;
    var sheetW = fmt.width * scale;
    var sheetH = fmt.height * scale;

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(offsetX, offsetY, sheetW, sheetH);
    ctx.strokeStyle = "#888";
    ctx.strokeRect(offsetX, offsetY, sheetW, sheetH);

    for (var i = 0; i < placements.length; i++) {
      var p = placements[i];
      ctx.fillStyle = p.color || "#999";
      ctx.fillRect(offsetX + p.x * scale, offsetY + p.y * scale, p.width * scale, p.height * scale);
      ctx.strokeStyle = "#ffffff";
      ctx.strokeRect(offsetX + p.x * scale, offsetY + p.y * scale, p.width * scale, p.height * scale);
    }

    target.appendChild(canvas);
  }

  function sortCombinationFormatKeys(combination) {
    return Object.keys(combination)
      .filter(function (name) {
        return !/au_logo|easy/i.test(String(name || ""));
      })
      .sort(function (a, b) {
        var da = a.match(/^__direct_(\d+)$/);
        var db = b.match(/^__direct_(\d+)$/);
        if (da && db) return Number(da[1]) - Number(db[1]);
        if (da) return -1;
        if (db) return 1;
        return (combination[b].sheets || 0) - (combination[a].sheets || 0);
      });
  }

  function buildSheetEntries(combination) {
    var formats = sortCombinationFormatKeys(combination);
    var sheetEntries = [];
    var index = 0;
    for (var i = 0; i < formats.length; i++) {
      var formatName = formats[i];
      var line = combination[formatName];
      var resolvedFormatName = line.directFormatName || formatName;
      var allocations = (line.allocations || []).slice().sort(function (a, b) {
        return (b.sheets || 0) - (a.sheets || 0);
      });

      if (!allocations.length) {
        sheetEntries.push({
          label: line.directPlancheLabel || calcT("sheet", "Planche") + " " + String.fromCharCode(65 + index),
          formatName: resolvedFormatName,
          sheets: line.sheets || 0,
          logoName: "",
          logoId: "",
          perSheet: Number((line.blueprint && line.blueprint.totalOnSheet) || 0),
          blueprint: line.blueprint,
          directQtyMode: Boolean(line.directQtyMode)
        });
        index += 1;
        continue;
      }

      for (var a = 0; a < allocations.length; a++) {
        var alloc = allocations[a];
        sheetEntries.push({
          label: calcT("sheet", "Planche") + " " + String.fromCharCode(65 + index),
          formatName: resolvedFormatName,
          sheets: alloc.sheets || 0,
          logoName: alloc.logoName || "",
          logoId: alloc.logoId || "",
          logos: Array.isArray(alloc.logos) ? alloc.logos : [],
          perSheet: Number(alloc.perSheet || 0),
          blueprint: alloc.blueprint || line.blueprint,
          directQtyMode: Boolean(line.directQtyMode)
        });
        index += 1;
      }
    }
    return sheetEntries;
  }

  function quoteLogoLabel(rawName) {
    var name = String(rawName || "").trim();
    var match = name.match(/^logo\s+(\d+)$/i);
    if (match) return calcT("by_logos", "logos").replace(/^par\s+/i, "").replace(/^by\s+/i, "").replace(/^per\s+/i, "") + " " + match[1];
    return name ? name.toLowerCase() : calcT("logo", "Logo").toLowerCase();
  }

  function quoteRowDetailLabel(sheet, rowSheets, logos) {
    if (sheet.logos && sheet.logos.length) {
      return sheet.logos
        .map(function (item) {
          var qty = Math.max(0, Number(item.perSheet || 0) * rowSheets);
          return qty + " " + quoteLogoLabel(item.logoName);
        })
        .join(" + ");
    }
    var source = (logos || []).find(function (logo) {
      return logo.id === sheet.logoId;
    });
    var logoName = sheet.logoName || (source && source.name) || calcT("logo", "Logo");
    var qtySingle = Math.max(0, Number(sheet.perSheet || 0) * rowSheets);
    return qtySingle + " " + quoteLogoLabel(logoName);
  }

  function quoteRowDetailTotals(sheet, rowSheets, logos) {
    var totals = {};
    if (sheet.logos && sheet.logos.length) {
      sheet.logos.forEach(function (item) {
        var qty = Math.max(0, Number(item.perSheet || 0) * rowSheets);
        var key = quoteLogoLabel(item.logoName);
        totals[key] = (totals[key] || 0) + qty;
      });
      return totals;
    }
    var source = (logos || []).find(function (logo) {
      return logo.id === sheet.logoId;
    });
    var logoName = sheet.logoName || (source && source.name) || calcT("logo", "Logo");
    var qtySingle = Math.max(0, Number(sheet.perSheet || 0) * rowSheets);
    var singleKey = quoteLogoLabel(logoName);
    totals[singleKey] = (totals[singleKey] || 0) + qtySingle;
    return totals;
  }

  function formatPreviewPriceEUR(value) {
    var n = Number(value);
    if (!isFinite(n)) return "\u2014";
    return n.toFixed(2).replace(".", ",") + "\u00a0\u20ac";
  }

  var MIN_SHEETS_SERIGRAPHIE = 10;
  var SERIGRAPHIC_PRODUCT_SIGNS = [
    "TRANSFERT_SERIGRAPHIQUE_MONOCHROME_EN_PLANCHE",
    "TRANSFERT_SERIGRAPHIQUE_MONOCHROME_COULEUR",
    "TRANSFERT_SERIGRAPHIQUE_OR_/_ARGENT",
    "TRANSFERT_SERIGRAPHIQUE_FLUO"
  ];

  var FORMAT_NAMES_BY_PRODUCT_SIGN = {
    DTF: ["Mètre", "A2", "A3", "A4"],
    SUBLIMATION: ["Mètre", "A2", "A3", "A4"],
    UVDTF: ["A2", "A3", "A4"],
    TRANSFERT_SERIGRAPHIQUE_MONOCHROME_EN_PLANCHE: ["A3+", "A4+", "A5", "A6", "A7"],
    TRANSFERT_SERIGRAPHIQUE_MONOCHROME_COULEUR: ["A3+"],
    "TRANSFERT_SERIGRAPHIQUE_OR_/_ARGENT": ["A3+"],
    TRANSFERT_SERIGRAPHIQUE_FLUO: ["A3+"],
    DTF_SOFTSHELL: ["Mètre", "A2", "A3"],
    DTF_PRO_MAX: ["Mètre", "A2", "A3"]
  };

  function isSerigraphicProduct(sign) {
    return SERIGRAPHIC_PRODUCT_SIGNS.indexOf(String(sign || "")) !== -1;
  }

  function billingSheetsForQuoteRow(actualSheets, productSign) {
    var n = Math.max(0, Number(actualSheets || 0));
    if (!isSerigraphicProduct(productSign)) return n;
    if (n <= 0) return n;
    var billed = Math.max(n, MIN_SHEETS_SERIGRAPHIE);
    return billed;
  }

  function escapeAttr(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function escapeDemandText(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function loyaltyTariffsTipHtml() {
    var accountHref = "/account";
    return (
      '<aside class="v3i-quote-tip v3i-quote-tip--promo" role="complementary" aria-label="' +
      escapeAttr(calcT("better_rates", "Obtenez de meilleurs tarifs")) +
      '">' +
      '<span class="v3i-quote-tip__icon" aria-hidden="true">%</span>' +
      '<div class="v3i-quote-tip__body">' +
      '<span class="v3i-quote-tip__label">' + escapeDemandText(calcT("better_rates", "Obtenez de meilleurs tarifs")) + '</span>' +
      '<p class="v3i-quote-tip__text">' + escapeDemandText(calcT("loyalty_discount_copy", "Jusqu’à -10 % de réduction avec notre programme de fidélité.")) + '</p>' +
      '<a class="v3i-quote-tip__link" href="' + escapeAttr(accountHref) + '">' + escapeDemandText(calcT("account_link", "Mon compte →")) + '</a>' +
      '</div>' +
      '</aside>'
    );
  }

  function forfaitImpressionTipHtml() {
    var forfaitHref = "https://www.sherpa-transfert.com/products/forfait-dimpression-dtf";
    return (
      '<aside class="v3i-quote-tip v3i-quote-tip--promo v3i-quote-tip--forfait" role="complementary" aria-label="' +
      escapeAttr(calcT("print_packages_aria", "Forfaits d’impression")) +
      '">' +
      '<span class="v3i-quote-tip__icon" aria-hidden="true">€</span>' +
      '<div class="v3i-quote-tip__body">' +
      '<span class="v3i-quote-tip__label">' + escapeDemandText(calcT("print_packages_label", "Pensez à nos forfaits d’impression")) + '</span>' +
      '<p class="v3i-quote-tip__text">' + escapeDemandText(calcT("print_packages_copy", "À partir de 9,9 € le mètre, quel que soit le design, avec nos forfaits d’impression.")) + '</p>' +
      '<a class="v3i-quote-tip__link" href="' + escapeAttr(forfaitHref) + '" target="_blank" rel="noopener noreferrer">' + escapeDemandText(calcT("print_packages_link", "Voir le forfait →")) + '</a>' +
      '</div>' +
      '</aside>'
    );
  }

  function drawFormatPreviews(target, combination, logos, product, selectedDelay, quoteRows) {
    target.innerHTML = "";

    var col = document.createElement("div");
    col.className = "v3i-previews-column";

    var grid = document.createElement("div");
    grid.className = "scenario-previews-grid";
    col.appendChild(grid);

    var sheetEntries = buildSheetEntries(combination);
    var logoById = {};
    (logos || []).forEach(function (logo) {
      logoById[logo.id] = logo;
    });
    for (var i = 0; i < sheetEntries.length; i++) {
      var sheet = sheetEntries[i];
      var block = document.createElement("div");
      block.className = "scenario-preview-block";

      var head = document.createElement("div");
      head.className = "scenario-preview-head";

      var headTop = document.createElement("div");
      headTop.className = "scenario-preview-head-top";

      var title = document.createElement("div");
      title.className = "scenario-preview-title";
      title.textContent = sheet.label;
      headTop.appendChild(title);

      var headAside = document.createElement("div");
      headAside.className = "scenario-preview-head-aside";

      var formatChip = document.createElement("span");
      formatChip.className = "scenario-preview-format-chip";
      formatChip.textContent = String(sheet.formatName || "").trim() || "\u2014";
      headAside.appendChild(formatChip);

      var qRow = quoteRows && quoteRows[i];
      var nSheets =
        qRow && qRow.sheets != null
          ? Math.max(0, Math.floor(Number(qRow.sheets)))
          : Math.max(0, Math.floor(Number(sheet.sheets || 0)));
      var qtyEl = document.createElement("span");
      qtyEl.className = "scenario-preview-sheet-qty";
      qtyEl.textContent = "\u00d7 " + nSheets;
      headAside.appendChild(qtyEl);

      var priceEl = document.createElement("span");
      priceEl.className = "scenario-preview-price";
      priceEl.textContent =
        qRow && isFinite(Number(qRow.price)) ? formatPreviewPriceEUR(qRow.price) : "\u2014";
      headAside.appendChild(priceEl);

      headTop.appendChild(headAside);
      head.appendChild(headTop);

      block.appendChild(head);

      var canvasWrap = document.createElement("div");
      canvasWrap.className = "scenario-preview-canvas";
      drawPreview(canvasWrap, sheet.blueprint);
      block.appendChild(canvasWrap);

      grid.appendChild(block);
    }

    target.appendChild(col);
  }

  function buildFormatList(productSign) {
    var names = FORMAT_NAMES_BY_PRODUCT_SIGN[productSign] || ["A3", "A4"];
    return names
      .map(function (name) {
        return window.CalculatorEngine.FORMAT_DIMENSIONS[name]
          ? { name: name, width: window.CalculatorEngine.FORMAT_DIMENSIONS[name].width, height: window.CalculatorEngine.FORMAT_DIMENSIONS[name].height }
          : null;
      })
      .filter(Boolean);
  }

  function nextColor(index) {
    var colors = ["#d5377b", "#37A6D5", "#18a601", "#f09710", "#8247e5", "#ff5d5d", "#008e9f", "#7b8f00", "#005ec9", "#cc6f00"];
    return colors[index % colors.length];
  }

  function hideLegacyUiV3Chrome() {
    function norm(s) {
      return String(s || "").replace(/\s+/g, " ").trim();
    }
    function isUiV3Title(t) {
      var n = norm(t);
      return /^UI\s*V3$/i.test(n) || /^1\s*UI\s*V3$/i.test(n) || /^UI\s*V3\s*$/i.test(n);
    }
    document.querySelectorAll(".imposition-v2-marker").forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll("#main-content h1, .blog-post-detail h1, .section-spacing h1").forEach(function (h) {
      if (!isUiV3Title(h.textContent)) return;
      var postTitle = h.closest(".post-title");
      if (postTitle) {
        postTitle.style.setProperty("display", "none", "important");
      } else {
        h.style.setProperty("display", "none", "important");
      }
    });
  }

  onReady(hideLegacyUiV3Chrome);

  function fetchEasyOrderAuLogoRangesFromStorefront() {
    var cfg = window.easyOrderPriceRangeGraphql;
    if (!cfg || !cfg.storefrontAccessToken || String(cfg.storefrontAccessToken).trim() === "") {
      return Promise.resolve(null);
    }
    var domain = String(cfg.shopDomain || "")
      .replace(/^https?:\/\//i, "")
      .split("/")[0]
      .trim();
    if (!domain) return Promise.resolve(null);
    var version = String(cfg.apiVersion || "2024-10").trim();
    var url = "https://" + domain + "/api/" + version + "/graphql.json";
    var gql =
      'query GetSherpaDiscountsMetafield { shop { metafield(namespace: "easy-order", key: "price-range-table") { value type } } }';
    return fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": String(cfg.storefrontAccessToken).trim()
      },
      body: JSON.stringify({ query: gql })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (body) {
        if (body.errors && body.errors.length) {
          throw new Error(body.errors[0].message || "GraphQL error");
        }
        var mf = body.data && body.data.shop && body.data.shop.metafield;
        if (!mf || mf.value == null || mf.value === "") {
          return null;
        }
        var raw = mf.value;
        var parsed;
        try {
          parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        } catch (eParse) {
          return null;
        }
        window.dtfEasyOrderAuLogoRanges = unwrapEasyOrderRangePayload(parsed);
        return window.dtfEasyOrderAuLogoRanges;
      })
      .catch(function () {
        return null;
      });
  }

  onReady(function initIsolatedImpositionOptimizer() {
    function waitForCalculatorEngineAndGraphql() {
      if (!window.CalculatorEngine) {
        window.setTimeout(waitForCalculatorEngineAndGraphql, 40);
        return;
      }
      var root = document.querySelector('[data-imposition-v3-scope="isolated"]');
      if (!root) return;
      fetchEasyOrderAuLogoRangesFromStorefront().finally(runIsolatedImpositionInit);
    }

    function runIsolatedImpositionInit() {
    var root = document.querySelector('[data-imposition-v3-scope="isolated"]');
    if (!root) return;

    var list = root.querySelector("[is-logo-params-list]");
    var template = root.querySelector("[is-logo-params-example]");
    var addButton = root.querySelector("[is-add-logo]");
    var calculateButton = root.querySelector("[is-calculate-button]");
    var clearButton = root.querySelector("[is-clear-button]");
    var resultsList = root.querySelector("[is-calculated-result-card-list]");
    var resultTemplate = root.querySelector("[is-calculated-result-card]");
    var screens = root.querySelectorAll("[is-calculator-wrapper]");
    var productSelect = root.querySelector("[is-product-types]");
    var delaySelect = root.querySelector("[is-delay-option]");
    var delayResultsSelect = root.querySelector("[is-delay-option-results]");
    var delayUserTouched = false;
    var delayDefaultApplied = false;

    if (!list || !template || !addButton || !calculateButton || !resultsList || !resultTemplate) return;

    var sheetList = root.querySelector("[is-sheet-params-list]");
    var sheetTemplate = root.querySelector("[is-sheet-params-example]");
    var addSheetButton = root.querySelector("[is-add-sheet]");
    var sheetsModeStack = root.querySelector("[is-sheets-mode-stack]");
    var logosModeStack = root.querySelector("[is-logos-mode-stack]");
    var modeLogosBtn = root.querySelector("[is-calc-mode-logos]");
    var modeSheetsBtn = root.querySelector("[is-calc-mode-sheets]");
    var calcMode = "sheets";

    function fillSheetFormatSelect(selectEl, productSign) {
      if (!selectEl) return;
      var prev = String(selectEl.value || "");
      var formats = buildFormatList(productSign);
      selectEl.innerHTML = "";
      for (var fi = 0; fi < formats.length; fi++) {
        var fmt = formats[fi];
        var opt = document.createElement("option");
        opt.value = fmt.name;
        var isMetre = isMetreFormatName(fmt.name);
        opt.textContent =
          fmt.name + (isMetre ? " " + calcT("metre_suffix", "(au mètre)") : "") + " — " + fmt.width + " \u00d7 " + fmt.height + " cm";
        selectEl.appendChild(opt);
      }
      if (
        prev &&
        Array.prototype.some.call(selectEl.options, function (o) {
          return o.value === prev;
        })
      ) {
        selectEl.value = prev;
      }
    }

    function refreshAllSheetFormatSelects() {
      if (!sheetList || !productSelect) return;
      var productSign = String(productSelect.value || "DTF");
      Array.prototype.forEach.call(sheetList.querySelectorAll("[is-sheet-format-select]"), function (sel) {
        fillSheetFormatSelect(sel, productSign);
      });
    }

    function collectSheetPlancheRows() {
      if (!sheetList) return [];
      var rows = sheetList.querySelectorAll("[is-sheet-params-example]");
      var out = [];
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var sel = row.querySelector("[is-sheet-format-select]");
        var qtyInp = row.querySelector("[is-sheet-qty-input]");
        var fmt = sel && String(sel.value || "").trim();
        var qty = Math.max(0, Math.floor(Number((qtyInp && qtyInp.value) || 0)));
        if (!fmt || qty <= 0) continue;
        out.push({
          name: fmt,
          qty: qty,
          plancheLabel: i < 26 ? calcT("sheet", "Planche") + " " + String.fromCharCode(65 + i) : calcT("sheet", "Planche") + " " + (i + 1)
        });
      }
      return out;
    }

    function renumberSheetBlocks() {
      if (!sheetList) return;
      Array.prototype.forEach.call(sheetList.querySelectorAll("[is-sheet-params-example]"), function (row, idx) {
        var t = row.querySelector("[is-sheet-block-title]");
        if (t) {
          t.textContent = idx < 26 ? calcT("sheet", "Planche") + " " + String.fromCharCode(65 + idx) : calcT("sheet", "Planche") + " " + (idx + 1);
        }
      });
    }

    function createExtraSheetRow() {
      if (!sheetTemplate || !sheetList) return null;
      var clone = sheetTemplate.cloneNode(true);
      clone.removeAttribute("id");
      var qtyIn = clone.querySelector("[is-sheet-qty-input]");
      if (qtyIn) qtyIn.value = "1";
      var sel = clone.querySelector("[is-sheet-format-select]");
      if (sel) {
        sel.removeAttribute("data-sheet-format-tiles-bound");
        if (productSelect) fillSheetFormatSelect(sel, String(productSelect.value || "DTF"));
      }
      var remove = document.createElement("button");
      remove.type = "button";
      remove.className = "v3i-logo-remove-btn";
      remove.textContent = calcT("remove", "Supprimer");
      remove.setAttribute("aria-label", calcT("remove_sheet", "Supprimer cette planche"));
      remove.addEventListener("click", function () {
        clone.remove();
        renumberSheetBlocks();
      });
      var params = clone.querySelector("[is-sheet-parameters-box]");
      var title = params && params.querySelector("[is-sheet-block-title]");
      if (params && title) {
        var head = document.createElement("div");
        head.className = "v3i-logo-card-head";
        title.parentNode.insertBefore(head, title);
        head.appendChild(title);
        head.appendChild(remove);
      } else {
        clone.appendChild(remove);
      }
      return clone;
    }

    function setCalcMode(mode) {
      calcMode = mode === "sheets" ? "sheets" : "logos";
      if (modeLogosBtn && modeSheetsBtn) {
        var logosActive = calcMode === "logos";
        modeLogosBtn.classList.toggle("active", logosActive);
        modeSheetsBtn.classList.toggle("active", !logosActive);
        modeLogosBtn.setAttribute("aria-pressed", logosActive ? "true" : "false");
        modeSheetsBtn.setAttribute("aria-pressed", logosActive ? "false" : "true");
      }
      if (logosModeStack) logosModeStack.classList.toggle("visuallyhidden", calcMode === "sheets");
      if (sheetsModeStack) sheetsModeStack.classList.toggle("visuallyhidden", calcMode !== "sheets");
      if (addButton) addButton.classList.toggle("visuallyhidden", calcMode === "sheets");
      if (addSheetButton) addSheetButton.classList.toggle("visuallyhidden", calcMode !== "sheets");
      if (calcMode === "sheets") {
        refreshAllSheetFormatSelects();
        renumberSheetBlocks();
      }
    }

    function unlockModeBoxForIsolated() {
      var slot = root.querySelector(".v3i-configurator-mode-slot");
      if (slot) slot.classList.remove("visuallyhidden");
    }

    root.addEventListener(
      "click",
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest("[is-calc-mode-sheets]")) {
          e.preventDefault();
          e.stopPropagation();
          setCalcMode("sheets");
          return;
        }
        if (t.closest("[is-calc-mode-logos]")) {
          e.preventDefault();
          setCalcMode("logos");
          /* ne pas stopPropagation : size-calculator doit recevoir le clic sur [is-mode-manual] (w("manual")) */
          return;
        }
      },
      true
    );

    unlockModeBoxForIsolated();
    if (productSelect) {
      productSelect.addEventListener("change", unlockModeBoxForIsolated);
    }

    if (productSelect && sheetList) {
      productSelect.addEventListener("change", function () {
        if (calcMode === "sheets") refreshAllSheetFormatSelects();
      });
    }

    if (addSheetButton && sheetList && sheetTemplate) {
      addSheetButton.addEventListener("click", function (event) {
        event.preventDefault();
        var n = sheetList.querySelectorAll("[is-sheet-params-example]").length;
        if (n >= 10) return;
        var row = createExtraSheetRow();
        if (row) {
          sheetList.appendChild(row);
          renumberSheetBlocks();
        }
      });
    }

    function rowFromElement(el, index) {
      var widthInput = el.querySelector("[is-width-input]");
      var heightInput = el.querySelector("[is-height-input]");
      var qtyInput = el.querySelector("[is-quantity-input]");
      var nameInput = el.querySelector('input[name="name"]') || el.querySelector('input[type="text"]');

      var name = (nameInput && String(nameInput.value || "").trim()) || calcT("logo", "Logo") + " " + (index + 1);
      var width = Number((widthInput && widthInput.value) || 0);
      var height = Number((heightInput && heightInput.value) || 0);
      var quantity = Math.max(0, Math.floor(Number((qtyInput && qtyInput.value) || 0)));

      return {
        id: "logo_" + index,
        name: name,
        width: width,
        height: height,
        quantity: quantity,
        color: nextColor(index)
      };
    }

    function collectLogos() {
      return Array.prototype.slice
        .call(list.querySelectorAll("[is-logo-params-example]"))
        .map(rowFromElement)
        .filter(function (logo) {
          return logo.width > 0 && logo.height > 0 && logo.quantity > 0;
        })
        .slice(0, 10);
    }

    function escapeDemandText(s) {
      return String(s == null ? "" : s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function formatDemandDims(w, h) {
      function fmt(n) {
        var x = Number(n);
        if (!isFinite(x)) return "0";
        var t = Math.round(x * 10) / 10;
        return t % 1 === 0 ? String(Math.round(t)) : t.toFixed(1);
      }
      return fmt(w) + " \u00d7 " + fmt(h) + " cm";
    }

    function renumberLogoBlocks() {
      Array.prototype.slice.call(list.querySelectorAll("[is-logo-params-example]")).forEach(function (row, idx) {
        var logoTitle = row.querySelector("[is-parameters-box] .calc-group-title");
        if (logoTitle) logoTitle.textContent = calcT("logo", "Logo") + " " + (idx + 1);
      });
    }

    function createExtraRow(index) {
      var clone = template.cloneNode(true);
      clone.removeAttribute("id");
      var configurator = clone.querySelector(".calculator__configurator");
      if (configurator) configurator.remove();
      clone.querySelectorAll("[is-input-mode], [is-upload-field], [is-product-types], [is-delay-option], [is-unit-cut], [is-amalgame-ability]").forEach(function (node) {
        var box = node.closest(".input--box");
        if (box) box.remove();
      });
      clone.querySelectorAll("[is-width-input], [is-height-input], [is-quantity-input]").forEach(function (input) {
        if (input.hasAttribute("is-width-input")) input.value = LOGO_DEFAULT_WIDTH_CM;
        if (input.hasAttribute("is-height-input")) input.value = LOGO_DEFAULT_HEIGHT_CM;
        if (input.hasAttribute("is-quantity-input")) input.value = LOGO_DEFAULT_QTY;
      });
      var remove = document.createElement("button");
      remove.type = "button";
      remove.className = "v3i-logo-remove-btn";
      remove.textContent = calcT("remove", "Supprimer");
      remove.setAttribute("aria-label", calcT("remove_logo", "Supprimer ce logo"));
      remove.addEventListener("click", function () {
        clone.remove();
        renumberLogoBlocks();
      });
      var params = clone.querySelector("[is-parameters-box]");
      var title = params && params.querySelector(".calc-group-title");
      if (params && title) {
        var head = document.createElement("div");
        head.className = "v3i-logo-card-head";
        title.parentNode.insertBefore(head, title);
        head.appendChild(title);
        head.appendChild(remove);
      } else {
        clone.appendChild(remove);
      }
      return clone;
    }

    function pickDefaultDelayValue(options) {
      var optionEntries = Array.prototype.slice.call(options || []);
      var exact = optionEntries.find(function (opt) {
        return parseDelayDays(opt.value) === 5 || parseDelayDays(opt.textContent) === 5;
      });
      return exact ? exact.value : (optionEntries[0] ? optionEntries[0].value : "");
    }

    function syncDelaySelectors() {
      if (!delaySelect || !delayResultsSelect) return;
      delayResultsSelect.innerHTML = "";
      Array.prototype.slice.call(delaySelect.options || []).forEach(function (opt) {
        delayResultsSelect.appendChild(opt.cloneNode(true));
      });
      if (!delayResultsSelect.options.length) return;
      if (!delayDefaultApplied) {
        var defaultValue = pickDefaultDelayValue(delayResultsSelect.options);
        if (defaultValue) {
          delaySelect.value = defaultValue;
          delayResultsSelect.value = defaultValue;
        }
        delayDefaultApplied = true;
        return;
      }
      var sourceValue = delaySelect.value;
      if (sourceValue && Array.prototype.some.call(delayResultsSelect.options, function (opt) { return opt.value === sourceValue; })) {
        delayResultsSelect.value = sourceValue;
      }
    }

    function setCalculating(active) {
      if (calculateButton) {
        calculateButton.disabled = !!active;
        calculateButton.classList.toggle("is-calculating", !!active);
        calculateButton.setAttribute("aria-busy", active ? "true" : "false");
      }
      Array.prototype.forEach.call(screens, function (sc) {
        sc.classList.toggle("is-calculating", !!active);
        sc.setAttribute("aria-busy", active ? "true" : "false");
      });
    }

    function restoreResultsDelayToHeader() {
      var delayRoot = root.querySelector("[is-results-delay-root]");
      var header = root.querySelector(".calc-results-header");
      var clearBtn = root.querySelector("[is-clear-button]");
      if (!delayRoot || !header) return;
      if (delayRoot.parentElement === header) return;
      header.appendChild(delayRoot);
      if (clearBtn && clearBtn.parentElement === header) {
        header.insertBefore(clearBtn, delayRoot);
      }
    }

    function mountResultsDelayInResultsStack(slotHostEl) {
      var delayRoot = root.querySelector("[is-results-delay-root]");
      var slot = slotHostEl && slotHostEl.querySelector("[is-results-delay-slot]");
      if (!delayRoot || !slot) return;
      slot.appendChild(delayRoot);
    }

    if (delaySelect && delayResultsSelect) {
      syncDelaySelectors();
      var delayObserver = new MutationObserver(function () {
        syncDelaySelectors();
      });
      delayObserver.observe(delaySelect, { childList: true, subtree: true });
      delayResultsSelect.addEventListener("change", function () {
        if (!delaySelect) return;
        delayUserTouched = true;
        delaySelect.value = delayResultsSelect.value;
        calculateButton.click();
      });
      delaySelect.addEventListener("change", function () {
        if (!delayResultsSelect) return;
        if (!delayUserTouched) syncDelaySelectors();
      });
    }

    addButton.addEventListener("click", function (event) {
      event.preventDefault();
      var currentRows = list.querySelectorAll("[is-logo-params-example]").length;
      if (currentRows >= 10) return;
      list.appendChild(createExtraRow(currentRows));
      renumberLogoBlocks();
    });

    function evaluateScenarioPricing(combination, product, productSign, selectedDelay, logosForMode) {
      var sheetEntries = buildSheetEntries(combination);
      var quoteRows = sheetEntries.map(function (sheet) {
        var actualSheets = Math.max(0, Number(sheet.sheets || 0));
        var rowSheets = billingSheetsForQuoteRow(actualSheets, productSign);
        var rowPrice = calculatorLineTotalPrice(product, productSign, sheet.formatName, selectedDelay, rowSheets);
        var dQty = Boolean(sheet.directQtyMode);
        return {
          label: sheet.label,
          format: sheet.formatName,
          sheets: rowSheets,
          price: rowPrice,
          unitPrice: rowSheets > 0 ? rowPrice / rowSheets : 0,
          baseSheets: actualSheets,
          logosPerSheet: Number(sheet.perSheet || 0),
          detailLabel: dQty
            ? calcT("direct_quantity", "Quantité directe (sans imposition logo)")
            : quoteRowDetailLabel(sheet, actualSheets, logosForMode),
          detailTotals: dQty ? {} : quoteRowDetailTotals(sheet, actualSheets, logosForMode)
        };
      });
      var quoteTotal = quoteRows.reduce(function (sum, row) {
        return sum + row.price;
      }, 0);
      var billedSheetsSum = quoteRows.reduce(function (sum, row) {
        return sum + row.sheets;
      }, 0);
      return {
        sheetEntries: sheetEntries,
        quoteRows: quoteRows,
        quoteTotal: quoteTotal,
        billedSheetsSum: billedSheetsSum
      };
    }

    function scenarioIsSingleFullAmalgam(scenario, logosForMode) {
      if (!scenario || !scenario.combination || !logosForMode || !logosForMode.length) return false;
      if (logosForMode.length < 2) return false;
      var combo = scenario.combination;
      var usedFormats = Object.keys(combo).filter(function (k) {
        return Number(combo[k].sheets || 0) > 0;
      });
      if (usedFormats.length !== 1) return false;
      var line = combo[usedFormats[0]];
      var allocs = line.allocations || [];
      if (allocs.length !== 1) return false;
      var a = allocs[0];
      if (!a.logos || !Array.isArray(a.logos) || a.logos.length !== logosForMode.length) return false;
      var wantIds = logosForMode
        .map(function (l) {
          return l.id;
        })
        .sort();
      var gotIds = a.logos
        .map(function (x) {
          return x.logoId;
        })
        .sort();
      for (var i = 0; i < wantIds.length; i++) {
        if (gotIds[i] !== wantIds[i]) return false;
      }
      for (var j = 0; j < a.logos.length; j++) {
        if (Number(a.logos[j].perSheet || 0) < 1) return false;
      }
      return true;
    }

    function pickCheapestLogoScenario(rankedScenarios, product, productSign, selectedDelay, logosForMode) {
      if (!Array.isArray(rankedScenarios) || !rankedScenarios.length) return null;
      var candidates = [
        {
          type: "current",
          label: calcT("current", "Actuel"),
          data: rankedScenarios[0]
        }
      ];

      var bestAmalgam = null;
      var bestAmalgamPrice = Infinity;
      for (var ia = 0; ia < rankedScenarios.length; ia++) {
        var sa = rankedScenarios[ia];
        if (!scenarioIsSingleFullAmalgam(sa, logosForMode)) continue;
        var pa = evaluateScenarioPricing(
          sa.combination,
          product,
          productSign,
          selectedDelay,
          logosForMode
        );
        if (pa.quoteTotal < bestAmalgamPrice) {
          bestAmalgamPrice = pa.quoteTotal;
          bestAmalgam = sa;
        }
      }
      if (bestAmalgam) {
        candidates.push({
          type: "allLogosOneSheet",
          label: calcT("one_sheet_all_logos", "1 planche (tous logos)"),
          data: bestAmalgam
        });
      }

      var bestTwo = null;
      var bestTwoPrice = Infinity;
      for (var ib = 0; ib < rankedScenarios.length; ib++) {
        var sb = rankedScenarios[ib];
        if (Number(sb && sb.totalSheets) !== 2) continue;
        var pb = evaluateScenarioPricing(
          sb.combination,
          product,
          productSign,
          selectedDelay,
          logosForMode
        );
        if (pb.quoteTotal < bestTwoPrice) {
          bestTwoPrice = pb.quoteTotal;
          bestTwo = sb;
        }
      }
      if (bestTwo) {
        candidates.push({
          type: "twoSheetsTotal",
          label: calcT("two_sheets_total", "2 planches (total)"),
          data: bestTwo
        });
      }

      var priced = candidates
        .map(function (candidate) {
          if (!candidate.data || !candidate.data.combination) return null;
          var pricing = evaluateScenarioPricing(
            candidate.data.combination,
            product,
            productSign,
            selectedDelay,
            logosForMode
          );
          return {
            type: candidate.type,
            label: candidate.label,
            scenario: candidate.data,
            pricing: pricing
          };
        })
        .filter(Boolean);

      if (!priced.length) return null;
      var typeTieOrder = { current: 0, allLogosOneSheet: 1, twoSheetsTotal: 2 };
      priced.sort(function (a, b) {
        if (a.pricing.quoteTotal !== b.pricing.quoteTotal) {
          return a.pricing.quoteTotal - b.pricing.quoteTotal;
        }
        if (a.pricing.billedSheetsSum !== b.pricing.billedSheetsSum) {
          return a.pricing.billedSheetsSum - b.pricing.billedSheetsSum;
        }
        return (typeTieOrder[a.type] || 9) - (typeTieOrder[b.type] || 9);
      });
      var winner = priced[0];
      return {
        type: winner.type,
        label: winner.label,
        comparatifLabel: winner.label,
        scenario: winner.scenario,
        pricing: winner.pricing
      };
    }

    calculateButton.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (calculateButton.classList.contains("is-calculating")) return;

        var isDirectSheets = calcMode === "sheets";
        var logos = isDirectSheets ? [] : collectLogos();
        var directEntries = [];
        if (isDirectSheets) {
          directEntries = collectSheetPlancheRows();
          if (!directEntries.length) return;
        } else {
          if (!logos.length) return;
        }
        setCalculating(true);

        function scheduleCalculate() {
          window.setTimeout(function () {
            try {
            restoreResultsDelayToHeader();

            var productSign = String((productSelect && productSelect.value) || "DTF");
            var selectedDelay = (delaySelect && delaySelect.value) || (delayResultsSelect && delayResultsSelect.value) || "";
            var unitCut = false;

            var product = (window.calculatorProducts || []).find(function (entry) {
              return entry.sign === productSign;
            });

            if (isSerigraphicProduct(productSign)) {
            }

            var ranked;
            if (isDirectSheets) {
              var combinationDirect = {};
              directEntries.forEach(function (entry, idx) {
                var fmtName = entry.name;
                var qtyM = entry.qty;
                var dimsD = window.CalculatorEngine.FORMAT_DIMENSIONS[fmtName];
                if (!dimsD || qtyM <= 0) return;
                combinationDirect["__direct_" + idx] = {
                  sheets: qtyM,
                  allocations: [],
                  directQtyMode: true,
                  directFormatName: fmtName,
                  directPlancheLabel: calcT("sheet", "Planche") + " " + String.fromCharCode(65 + idx),
                  blueprint: {
                    format: { width: dimsD.width, height: dimsD.height, name: fmtName },
                    placements: [],
                    totalOnSheet: 0
                  }
                };
              });
              if (!Object.keys(combinationDirect).length) return;
              ranked = [{ combination: combinationDirect }];
            } else {
              var formats = buildFormatList(productSign);
              var maxDemand = logos.reduce(function (max, logo) {
                return Math.max(max, Number(logo.quantity || 0));
              }, 0);
              var engineResult = window.CalculatorEngine.optimize({
                logos: logos,
                formats: formats,
                spacingCm: SPACING_CM,
                allowRotate: true,
                maxSheetsPerFormat: Math.max(250, maxDemand),
                pricingFn: function (formatName, sheets) {
                  return calculatorLineTotalPrice(product, productSign, formatName, selectedDelay, sheets);
                },
                extraCostFn: function () {
                  if (!unitCut) return 0;
                  var totalDemand = logos.reduce(function (sum, logo) {
                    return sum + logo.quantity;
                  }, 0);
                  return 0.15 * totalDemand;
                }
              });
              ranked = engineResult.ranked.slice();
            }
            if (!ranked.length) return;

            var scenario = ranked[0];
            var scenarioPricing = evaluateScenarioPricing(
              scenario.combination,
              product,
              productSign,
              selectedDelay,
              logos
            );
            if (!isDirectSheets) {
              var cheapestLogoScenario = pickCheapestLogoScenario(
                ranked,
                product,
                productSign,
                selectedDelay,
                logos
              );
              if (!cheapestLogoScenario) return;
              scenario = cheapestLogoScenario.scenario;
              scenarioPricing = cheapestLogoScenario.pricing;
            }

            resultsList.querySelectorAll("[is-calculated-result-card]").forEach(function (card) {
              card.remove();
            });

            var card = resultTemplate.cloneNode(true);
            card.classList.remove("rejected");
            card.classList.add("best--offer", "best-only-card");

            var formatLabel = card.querySelector("[is-format]");
            var sizeLabel = card.querySelector("[is-size]");
            var sheetsLabel = card.querySelector("[is-sheets-qty]");
            var totalLabel = card.querySelector("[is-total-price]");
            var perUnitLabel = card.querySelector("[is-price-per-unit]");
            var perLogoLabel = card.querySelector("[is-price-per-logo]");
            var listLabel = card.querySelector("[is-logo-info-list]");
            var preview = card.querySelector("[is-canvas-place]");
            var link = card.querySelector("[is-product-link]");

            card.setAttribute("data-v3-card", "1");
            if (formatLabel) {
              var formatBlock = formatLabel.closest(".calculations--result__card--format");
              if (formatBlock) formatBlock.setAttribute("data-v3-head", "1");
            }
            if (listLabel) {
              var infoBlock = listLabel.closest(".calculations--result__card--info");
              if (infoBlock) infoBlock.setAttribute("data-v3-left", "1");
            }
            if (preview) preview.setAttribute("data-v3-right", "1");

            var sheetEntries = scenarioPricing.sheetEntries;
            var quoteRows = scenarioPricing.quoteRows;
            var quoteTotal = scenarioPricing.quoteTotal;
            var billedSheetsSum = scenarioPricing.billedSheetsSum;
            var totalLogoMap = {};
            if (!isDirectSheets) {
              quoteRows.forEach(function (row) {
                Object.keys(row.detailTotals || {}).forEach(function (key) {
                  totalLogoMap[key] = (totalLogoMap[key] || 0) + Number(row.detailTotals[key] || 0);
                });
              });
            }

            var demandRowsHtml = isDirectSheets
              ? directEntries
                  .map(function (e) {
                    return (
                      '<div class="scenario-demand-row">' +
                      '<span class="scenario-demand-swatch" style="background-color:#3F72E5;" aria-hidden="true"></span>' +
                      '<div class="scenario-demand-main">' +
                      '<span class="scenario-demand-logo">' +
                      escapeDemandText(e.plancheLabel) +
                      "</span>" +
                      '<span class="scenario-demand-dims">' +
                      escapeDemandText(e.name) +
                      "</span>" +
                      "</div>" +
                      '<span class="scenario-demand-qty">\u00d7 ' +
                      e.qty +
                      "</span>" +
                      "</div>"
                    );
                  })
                  .join("")
              : logos
                  .map(function (logo) {
                    var demandQty = Math.max(0, Number(logo.quantity || 0));
                    return (
                      '<div class="scenario-demand-row">' +
                      '<span class="scenario-demand-swatch" style="background-color:' +
                      logo.color +
                      ';" aria-hidden="true"></span>' +
                      '<div class="scenario-demand-main">' +
                      '<span class="scenario-demand-logo">' +
                      escapeDemandText(logo.name) +
                      "</span>" +
                      '<span class="scenario-demand-dims">' +
                      formatDemandDims(logo.width, logo.height) +
                      "</span>" +
                      "</div>" +
                      '<span class="scenario-demand-qty">\u00d7 ' +
                      demandQty +
                      "</span>" +
                      "</div>"
                    );
                  })
                  .join("");
            var totalLogoLabel = isDirectSheets
              ? directEntries
                  .map(function (e, i) {
                    return (
                      calcT("sheet", "Planche") + " " +
                      String.fromCharCode(65 + i) +
                      " : " +
                      e.qty +
                      " \u00d7 " +
                      e.name
                    );
                  })
                  .join(" \u00b7 ")
              : Object.keys(totalLogoMap)
                  .sort()
                  .map(function (key) {
                    return totalLogoMap[key] + " " + key;
                  })
                  .join(" + ");

            formatLabel.textContent = "";
            sizeLabel.textContent = "";
            sheetsLabel.textContent = "x " + billedSheetsSum;
            totalLabel.textContent = quoteTotal.toFixed(2) + "€ HT";
            totalLabel.dataset.price = String(quoteTotal);
            perUnitLabel.textContent = billedSheetsSum > 0 ? (quoteTotal / billedSheetsSum).toFixed(2) + calcT("per_sheet", "€ / planche") : "0" + calcT("per_sheet", "€ / planche");
            perLogoLabel.textContent = isDirectSheets
              ? "— (" + calcT("direct_sheets_mode", "mode planches") + ")"
              : logos.length
                ? (quoteTotal / logos.reduce(function (sum, logo) { return sum + logo.quantity; }, 0)).toFixed(2) + calcT("per_logo", "€ / logo")
                : "0" + calcT("per_logo", "€ / logo");
            var easyOrderPanelHtml = "";
            if (!isDirectSheets && productSign === "DTF" && logos.length) {
              var easyProd = window.easyOrderDtfProduct;
              var canEasyOrder =
                easyOrderAuLogoRangesHasPrices() ||
                (easyProd && Array.isArray(easyProd.variants));
              if (canEasyOrder) {
                var eoParts = [];
                var eoLinePrices = [];
                var eoSum = 0;
                for (var eoi = 0; eoi < logos.length; eoi++) {
                  var lineP = easyOrderLineTotalHt(easyProd, logos[eoi], selectedDelay);
                  eoLinePrices.push(lineP);
                  eoSum += lineP;
                }
                var eoSumRaw = eoSum;
                eoSum = applyEasyOrderMinTotalHt(eoSum);
                var eoMinApplied = eoSum > eoSumRaw;
                for (var eoj = 0; eoj < logos.length; eoj++) {
                  var lo = logos[eoj];
                  var displayP = eoLinePrices[eoj];
                  if (eoMinApplied && logos.length === 1) {
                    displayP = eoSum;
                  }
                  eoParts.push(
                    '<div class="v3i-quote-item v3i-quote-item--easy-order" data-easy-order-qty="' +
                    String(Math.max(0, Math.floor(Number(lo.quantity || 0)))) +
                    '">' +
                    '<div class="v3i-quote-line">' +
                    '<div class="v3i-quote-labels">' +
                    '<span class="v3i-quote-title">' +
                    escapeDemandText(lo.name) +
                    "</span>" +
                    "</div>" +
                    '<div class="v3i-quote-aside">' +
                    '<span class="v3i-quote-line-price">' +
                    displayP.toFixed(2) +
                    "€</span>" +
                    "</div>" +
                    "</div>" +
                    '<div class="v3i-quote-unit-hint">' + escapeDemandText(calcT("tax_excl", "HT")) + '</div>' +
                    "</div>"
                  );
                }
                if (eoMinApplied && logos.length > 1) {
                  var eoComplement = eoSum - eoSumRaw;
                  eoParts.push(
                    '<div class="v3i-quote-item v3i-quote-item--easy-order" data-easy-order-qty="1">' +
                    '<div class="v3i-quote-line">' +
                    '<div class="v3i-quote-labels">' +
                    '<span class="v3i-quote-title">' + escapeDemandText(calcT("minimum_order_price", "Prix minimum de commande")) + '</span>' +
                    "</div>" +
                    '<div class="v3i-quote-aside">' +
                    '<span class="v3i-quote-line-price">' +
                    eoComplement.toFixed(2) +
                    "€</span>" +
                    "</div>" +
                    "</div>" +
                    '<div class="v3i-quote-unit-hint">' + escapeDemandText(calcT("tax_excl", "HT")) + '</div>' +
                    "</div>"
                  );
                }
                easyOrderPanelHtml =
                  '<div class="scenario-quote-panel scenario-quote-panel--easy-order">' +
                  '<div class="scenario-section-label">' + escapeDemandText(calcT("easy_order_quote", "Devis Easy order")) + '</div>' +
                  '<p class="v3i-easy-order-tagline">' +
                  escapeDemandText(calcT("easy_order_description", "Fini les amalgames fastidieux.")) +
                  "</p>" +
                  '<div class="scenario-quote-card v3i-quote-card v3i-quote-card--easy-order">' +
                  eoParts.join("") +
                  '<div class="v3i-quote-total">' +
                  '<div class="v3i-quote-total-main">' +
                  '<span class="v3i-quote-total-label">TOTAL</span>' +
                  "</div>" +
                  '<div class="v3i-quote-total-price">' +
                  '<span class="v3i-quote-total-eur">' +
                  eoSum.toFixed(2) +
                  "€</span>" +
                  '<span class="v3i-quote-total-ht">' + escapeDemandText(calcT("tax_excl", "HT")) + '</span>' +
                  "</div>" +
                  "</div>" +
                  "</div>" +
                  "</div>";
              }
            }
            var impositionsSectionHtml = isDirectSheets
              ? ""
              : '<div class="scenario-previews-wrap">' +
                '<div class="scenario-section-label">' + escapeDemandText(calcT("results_impositions", "Résultat des impositions")) + '</div>' +
                '<div is-results-previews-slot></div>' +
                "</div>";
            listLabel.innerHTML =
              '<div class="scenario-left-stack">' +
              '<div class="scenario-demand-card">' +
              '<div class="scenario-section-label">' +
              (isDirectSheets ? calcT("quantities_entered", "Quantités saisies") : calcT("customer_request", "Demande client")) +
              "</div>" +
              '<div class="scenario-demand-list">' + demandRowsHtml + "</div>" +
              "</div>" +
              impositionsSectionHtml +
              "</div>";

            preview.innerHTML =
              '<div class="scenario-right-stack">' +
              '<div class="v3i-delay-slot" is-results-delay-slot></div>' +
              '<div class="scenario-quote-panel">' +
              '<div class="scenario-section-label">' + escapeDemandText(calcT("sheet_quote", "Devis en planche")) + '</div>' +
              '<div class="scenario-quote-card v3i-quote-card">' +
              quoteRows
                .map(function (row) {
                  return (
                    '<div class="v3i-quote-item">' +
                    '<div class="v3i-quote-line">' +
                    '<div class="v3i-quote-labels">' +
                    '<span class="v3i-quote-title">' +
                    row.label +
                    "</span>" +
                    "</div>" +
                    '<div class="v3i-quote-aside">' +
                    '<span class="v3i-chip v3i-chip--format">' +
                    row.format +
                    "</span>" +
                    '<span class="v3i-chip v3i-chip--qty">× ' +
                    row.sheets +
                    "</span>" +
                    '<span class="v3i-quote-line-price">' +
                    row.price.toFixed(2) +
                    "€</span>" +
                    "</div>" +
                    "</div>" +
                    '<div class="v3i-quote-unit-hint">(' +
                    row.unitPrice.toFixed(2) +
                    calcT("per_sheet", "€ / planche") + ")</div>" +
                    "</div>"
                  );
                })
                .join("") +
              '<div class="v3i-quote-total">' +
              '<div class="v3i-quote-total-main">' +
              '<span class="v3i-quote-total-label">TOTAL</span>' +
              "</div>" +
              '<div class="v3i-quote-total-price">' +
              '<span class="v3i-quote-total-eur">' +
              quoteTotal.toFixed(2) +
              "€</span>" +
              '<span class="v3i-quote-total-ht">' + escapeDemandText(calcT("tax_excl", "HT")) + '</span>' +
              "</div>" +
              "</div>" +
              "</div>" +
              "</div>" +
              easyOrderPanelHtml +
              '<div class="calculator__actions v3i-primary-action-row v3i-quote-pdf-actions">' +
              '<button type="button" class="button calculator--btn" is-download-quote-pdf>' + escapeDemandText(calcT("download_pdf", "Télécharger en PDF")) + '</button>' +
              "</div>" +
              loyaltyTariffsTipHtml() +
              forfaitImpressionTipHtml() +
              "</div>";

            mountResultsDelayInResultsStack(preview);

            var previewsSlot = listLabel.querySelector("[is-results-previews-slot]");
            if (previewsSlot) {
              drawFormatPreviews(previewsSlot, scenario.combination, logos, product, selectedDelay, quoteRows);
            }

            if (link) {
              var firstKey = Object.keys(scenario.combination).find(function (name) {
                return !/au_logo|easy/i.test(String(name || ""));
              });
              var firstLine = firstKey && scenario.combination[firstKey];
              var firstFormat =
                (firstLine && firstLine.directFormatName) || firstKey;
              var variant = pickVariantPrice(product, firstFormat, selectedDelay);
              if (variant && variant.handle && variant.id) {
                link.href = "/products/" + variant.handle + "?variant=" + variant.id;
              }
            }
            resultsList.appendChild(card);

            if (screens.length === 2) {
              screens[0].classList.add("visuallyhidden");
              screens[1].classList.remove("visuallyhidden");
            }
          } finally {
            setCalculating(false);
          }
        }, 16);
        }

        // Sherpa Volume campaigns are already serialized into the calculator pricing context.
        // Do not wait for legacy Shopacado/Appikon volume rows.
        scheduleCalculate();
      },
      true
    );

    if (clearButton) {
      clearButton.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          restoreResultsDelayToHeader();
          list.querySelectorAll("[is-logo-params-example]").forEach(function (row, idx) {
            if (idx > 0) row.remove();
          });
          var first = list.querySelector("[is-logo-params-example]");
          if (first) {
            var w = first.querySelector("[is-width-input]");
            var h = first.querySelector("[is-height-input]");
            var q = first.querySelector("[is-quantity-input]");
            if (w) w.value = LOGO_DEFAULT_WIDTH_CM;
            if (h) h.value = LOGO_DEFAULT_HEIGHT_CM;
            if (q) q.value = LOGO_DEFAULT_QTY;
          }
          resultsList.querySelectorAll("[is-calculated-result-card]").forEach(function (card) {
            card.remove();
          });
          if (screens.length === 2) {
            screens[0].classList.remove("visuallyhidden");
            screens[1].classList.add("visuallyhidden");
          }
          if (calcMode === "sheets" && sheetList && sheetTemplate) {
            sheetList.querySelectorAll("[is-sheet-params-example]").forEach(function (row, idx) {
              if (idx > 0) row.remove();
            });
            var firstSh = sheetList.querySelector("[is-sheet-params-example]");
            if (firstSh) {
              var sq = firstSh.querySelector("[is-sheet-qty-input]");
              if (sq) sq.value = "1";
              var head = firstSh.querySelector(".v3i-logo-card-head");
              if (head) {
                var rm = head.querySelector(".v3i-logo-remove-btn");
                if (rm) rm.remove();
                var st = head.querySelector("[is-sheet-block-title]");
                if (st && st.parentNode === head) {
                  head.parentNode.insertBefore(st, head);
                  head.remove();
                }
              }
            }
            refreshAllSheetFormatSelects();
            renumberSheetBlocks();
          }
        },
        true
      );
    }

    renumberLogoBlocks();
    renumberSheetBlocks();
    setCalcMode("sheets");
    }

    waitForCalculatorEngineAndGraphql();
  });
})();